<template>
  <div>
    <div class="m-background m-background--media-1"></div>
    <div class="m-background__overlay"></div>
    <img src="~@/assets/images/rics-logo.png" class="m-logo m-logo--top-right" />
    <div class="l-container">
      <ConfidenceSurvey />
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
// import { mapActions } from 'vuex';
import ConfidenceSurvey from '../components/ConfidenceSurvey';

export default {
  data() {
    return {
      responses: {
        email: '',
        something: 'hello',
      },
    };
  },
  components: {
    ConfidenceSurvey,
  },
  computed: {
    comparePasswords() {
      return this.password === this.passwordConfirm ? true : 'Passwords don\'t match';
    },
  },
  methods: {
    // ...mapActions(['userSignUp']),
    // userSignUp(responses) {
    //   // firebase.auth().signInAnonymously().catch(function (error) {
    //     axios.post('https://rics-megafutures.firebaseio.com/responses.json', responses)
    //       .then(result => console.log(result))
    //       .catch(error => console.log(error));
    //   // });
    // },
  },
};
</script>

<style lang="scss" scoped>
  .v-form {
    margin-top: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Confidence.vue